import { FC, useEffect, useState } from 'react';
import { Button, Input, message, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { Verify2FAStepProps } from 'models/form';

import Utils from 'utils/utils';

import { useAppSelector, useTranslate } from 'hooks';

import { setVerify2FAStep } from 'features/verify2FA/verify2FASlice';

import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';
import i18n from '../../utils/i18n';

export const VerifyQrCode: FC<Verify2FAStepProps> = () => {
	const qr = useAppSelector((state) => state.verify2FA.qrCode);
	const [copied, setCopied] = useState(false);
	const { continueText, scanQrText, cantScanText, copyOrEnterCodeText } = useTranslate([
		'continueText',
		'scanQrText',
		'cantScanText',
		'copyOrEnterCodeText',
	]);
	const dispatch = useDispatch();
	useEffect(() => {
		if (copied) {
			message.success(i18n.t('copiedText') as string, 3).then(() => {
				setCopied(false);
			});
		}
	}, [copied]);
	return (
		<div className="modal-content">
			{isMobile ? '' : <Typography.Text>{scanQrText}</Typography.Text>}
			{isMobile ? '' : <img src={qr.tfa_qr_uri} alt="qr" className="modal-qr" />}
			<Typography.Text>{isMobile ? copyOrEnterCodeText : cantScanText}</Typography.Text>
			<div className="modal-input">
				<Input disabled={true} value={qr.tfa_secret} />
				<Button
					className="modal-copy"
					onClick={() => {
						Utils.copyText(qr.tfa_secret);
						setCopied(true);
					}}
					type="link"
					icon={<CopyIcon className="copyIcon" />}
				/>
			</div>
			<Button type="primary" className="modal-button" onClick={() => dispatch(setVerify2FAStep(2))}>
				{continueText}
			</Button>
		</div>
	);
};
